/**
 * @param resizeObserver A ResizeObserver object used to track changes of a DOM element's bounding box
 * @returns a callback that attaches the resize observer to the target element
 */
export const addResizeObserverToElement = (resizeObserver: ResizeObserver) => {
  return el => {
    if (el) {
      resizeObserver.observe(el)
    } else {
      resizeObserver.disconnect()
    }
  }
}
